import { useNewCode } from '@calendly/feature-check-react'
import { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const CRM_GOOGLE_FORMS_FLAG_KEY = 'crm_google_forms_feature'
const CRM_TYPEFORM_FLAG_KEY = 'crm_typeform_feature'
const CONTACT_IMPORT_RESUME_PARAM = 'contact_import_entry'
const DEFAULT_IMPORT_ENTRY_POINT = 'file'

export const useImportContactsModalState = () => {
  const history = useHistory()
  const location = useLocation()
  const googleFormsFlag = useNewCode(CRM_GOOGLE_FORMS_FLAG_KEY)
  const typeformFlag = useNewCode(CRM_TYPEFORM_FLAG_KEY)
  const isGoogleFormsEnabled = googleFormsFlag?.enabled ?? false
  const isTypeformEnabled = typeformFlag?.enabled ?? false
  const [importEntryPoint, setImportEntryPoint] = useState(null)

  const clearResumeParam = useCallback(() => {
    const params = new URLSearchParams(location.search)

    if (!params.has(CONTACT_IMPORT_RESUME_PARAM)) {
      return
    }

    params.delete(CONTACT_IMPORT_RESUME_PARAM)

    const search = params.toString()
    history.replace({
      pathname: location.pathname,
      search: search ? `?${search}` : '',
      hash: location.hash,
    })
  }, [history, location.hash, location.pathname, location.search])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const resumedEntryPoint = params.get(CONTACT_IMPORT_RESUME_PARAM)

    if (!resumedEntryPoint) {
      return
    }

    if (resumedEntryPoint === 'typeform') {
      if (typeof typeformFlag?.enabled === 'undefined') {
        return
      }

      if (isTypeformEnabled) {
        setImportEntryPoint('typeform')
      }

      clearResumeParam()
      return
    }

    if (resumedEntryPoint === 'google_forms') {
      if (typeof googleFormsFlag?.enabled === 'undefined') {
        return
      }

      if (isGoogleFormsEnabled) {
        setImportEntryPoint('google_forms')
      }
    }

    clearResumeParam()
  }, [
    clearResumeParam,
    googleFormsFlag?.enabled,
    isGoogleFormsEnabled,
    isTypeformEnabled,
    location.search,
    typeformFlag?.enabled,
  ])

  const openImportModal = useCallback(({ importEntryPoint: nextEntryPoint = DEFAULT_IMPORT_ENTRY_POINT } = {}) => {
    setImportEntryPoint(nextEntryPoint)
  }, [])

  const closeImportModal = useCallback(() => {
    setImportEntryPoint(null)
  }, [])

  return {
    importEntryPoint,
    isImportModalOpen: importEntryPoint !== null,
    openImportModal,
    closeImportModal,
  }
}
